export default "__VITE_ASSET__Bj64ccTA__"